import styled from '@emotion/styled';

export const Container = styled.form`
	padding: 15px 20px;
	background: #ecedf2;
	position: relative;
	display: flex;
	border-top: 1px solid #ecedf2;

	@media (max-width: 991px) {
		background: transparent;
		padding: 12px;
	}

	& > input {
		width: calc(100% - 64px);
		height: 43px;
		background: #fff;
		overflow: auto;
		padding: 12px 18px;
		display: inline-block;
		border-radius: 30px;
		font-size: 12px;
		resize: none;

		@media (max-width: 991px) {
			width: 100%;
			padding-right: 42px;
			background: #ecedf2;
			color: #696977;
		}
	}

	& > button {
		height: 40px;
		width: 40px;
		border-radius: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f3123c;
		transition: all 300ms ease;
		margin-left: 10px;
		color: #fff;

		&:disabled {
			cursor: not-allowed;
			background-color: transparent;
			color: #AEAEBA;
		}

		@media (max-width: 991px) {
			position: absolute;
			right: 10px;
			top: 50%;
			transform: translateY(-50%);
			padding-left: 0;
			border-top-right-radius: 30px;
			border-bottom-right-radius: 30px;
		}
	}
`;
